<!-- TITLE -->
<dhp-contact-header></dhp-contact-header>

<!-- QUESTION -->
<div
  class="grid min-h-[366px] grid-cols-1 gap-6 bg-primary-background px-4 py-8 md:grid-cols-2 md:px-8 md:py-16"
>
  <div class="w-full max-w-xl md:w-1/2">
    <div class="text-3xl leading-snug font-medium text-primary-text">
      {{ 'pages.contact.question.title' | translate }}
    </div>
  </div>
  <div class="flex flex-col gap-6">
    <div class="text-lg text-primary-text">
      {{ 'pages.contact.question.description' | translate }}
    </div>
    <button class="btn-secondary btn w-fit" routerLink="/help">
      {{ 'pages.contact.question.faqButton' | translate }}
    </button>
  </div>
</div>

<!-- Contact Section -->
<!-- Should be min-h-[600px] when form is active -->
<div class="flex flex-col items-start gap-5 px-4 py-10 md:flex-row md:px-8">
  <!-- Text Section -->
  <div class="flex w-full flex-row gap-5 md:w-1/2">
    <!-- First Div -->
    <div class="w-full md:w-1/2">
      <div class="text-lg font-medium text-orange-500">
        {{ 'pages.contact.form.leaveMessage' | translate }}
      </div>
      <div class="text-xl font-medium text-neutral-800">
        {{ 'pages.contact.form.generalInquiry' | translate }}
      </div>
    </div>
  </div>

  <!-- Form Section -->
  <div class="flex w-full flex-col gap-6 md:w-1/2">
    <a
      class="btn-secondary btn w-fit"
      [href]="'mailto:websupport@denhollander.info'"
    >
      {{ 'pages.helpPage.askQuestion' | translate }}
    </a>
    <!-- Form disabled as submit not yet active -->
    <form
      class="hidden space-y-5"
      [formGroup]="contactForm"
      (ngSubmit)="onSubmit()"
    >
      <!-- First Row (Naam and Voornaam) -->
      <div class="flex flex-col gap-5 md:flex-row">
        <div class="flex flex-1 flex-col">
          <label class="mb-1 text-base text-neutral-800" for="naam"
            >{{ 'pages.contact.form.name' | translate }}*</label
          >
          <input
            class="input w-full rounded-none"
            id="naam"
            [placeholder]="'pages.contact.form.name' | translate"
            type="text"
            formControlName="naam"
            required
          />
          @if (
            contactForm.get('naam')?.invalid && contactForm.get('naam')?.touched
          ) {
            <div class="mt-1 text-sm text-error-text">
              {{ 'pages.contact.form.nameRequired' | translate }}
            </div>
          }
        </div>
        <div class="flex flex-1 flex-col">
          <label class="mb-1 text-base text-neutral-800" for="voornaam">
            {{ 'pages.contact.form.firstName' | translate }}*
          </label>
          <input
            class="input w-full rounded-none"
            id="voornaam"
            [placeholder]="'pages.contact.form.firstName' | translate"
            type="text"
            formControlName="voornaam"
            required
          />
          @if (
            contactForm.get('voornaam')?.invalid &&
            contactForm.get('voornaam')?.touched
          ) {
            <div class="mt-1 text-sm text-error-text">
              {{ 'pages.contact.form.firstNameRequired' | translate }}
            </div>
          }
        </div>
      </div>

      <!-- Second Row (E-mailadres and Telefoonnummer) -->
      <div class="flex flex-col gap-5 md:flex-row">
        <!-- Email Address Field -->
        <div class="flex flex-1 flex-col">
          <label class="mb-1 text-base text-neutral-800" for="email">
            {{ 'pages.contact.form.email' | translate }}*
          </label>
          <input
            class="input w-full rounded-none"
            id="email"
            [placeholder]="'pages.contact.form.email' | translate"
            type="email"
            formControlName="email"
            required
          />
          @if (
            contactForm.get('email')?.invalid &&
            contactForm.get('email')?.touched
          ) {
            <div class="mt-1 text-sm text-error-text">
              @if (contactForm.get('email')?.errors?.['required']) {
                <span>
                  {{ 'pages.contact.form.emailRequired' | translate }}
                </span>
              }
              @if (contactForm.get('email')?.errors?.['email']) {
                <span>
                  {{ 'pages.contact.form.emailInvalid' | translate }}
                </span>
              }
            </div>
          }
        </div>
        <!-- Phone Number Field -->
        <div class="flex flex-1 flex-col">
          <label class="mb-1 text-base text-neutral-800" for="telefoonnummer">
            {{ 'pages.contact.form.phoneNumber' | translate }}*
          </label>
          <input
            class="input w-full rounded-none"
            id="telefoonnummer"
            [placeholder]="'pages.contact.form.phoneNumber' | translate"
            type="tel"
            formControlName="telefoonnummer"
            required
          />
          @if (
            contactForm.get('telefoonnummer')?.invalid &&
            contactForm.get('telefoonnummer')?.touched
          ) {
            <div class="mt-1 text-sm text-error-text">
              {{ 'pages.contact.form.phoneNumberRequired' | translate }}
            </div>
          }
        </div>
      </div>

      <!-- Third Row (Kies een onderwerp) -->
      <div class="flex flex-col gap-1">
        <label class="mb-1 text-base text-neutral-800" for="onderwerp">
          {{ 'pages.contact.form.subject' | translate }}
        </label>
        <select
          class="select w-full rounded-none"
          id="onderwerp"
          formControlName="onderwerp"
        >
          <option value="">
            {{ 'pages.contact.form.selectSubject' | translate }}
          </option>
          <option value="onderwerp1">
            {{ 'pages.contact.form.subjectOption1' | translate }}
          </option>
          <option value="onderwerp2">
            {{ 'pages.contact.form.subjectOption2' | translate }}
          </option>
        </select>
      </div>

      <!-- Fourth Row (Bericht) -->
      <div class="flex flex-col gap-1">
        <label class="mb-1 text-base text-neutral-800" for="bericht">
          {{ 'pages.contact.form.message' | translate }}*
        </label>
        <textarea
          class="textarea h-40 w-full rounded-none"
          id="bericht"
          [placeholder]="'pages.contact.form.messagePlaceholder' | translate"
          formControlName="bericht"
          required
        ></textarea>
        @if (
          contactForm.get('bericht')?.invalid &&
          contactForm.get('bericht')?.touched
        ) {
          <div class="mt-1 text-sm text-error-text">
            {{ 'pages.contact.form.messageRequired' | translate }}
          </div>
        }
      </div>

      <!-- Submit Button -->
      <button
        class="btn-primary btn"
        [disabled]="contactForm.invalid"
        type="submit"
      >
        {{ 'pages.contact.form.send' | translate }}
      </button>
    </form>
  </div>
</div>

<!-- Contact Information Section -->
<div class="flex min-h-[326px] flex-col px-4 py-16 md:flex-row md:px-8">
  <div class="mb-5 w-full md:mb-0 md:w-1/2">
    <div class="text-lg font-medium text-orange-500">
      {{ 'pages.contact.info.title' | translate }}
    </div>
  </div>
  <div class="flex w-full flex-col gap-5 md:w-1/2 md:flex-row">
    <div class="flex flex-col gap-1 text-xl text-neutral-800 md:w-1/2">
      <div>{{ 'pages.contact.info.companyName' | translate }}</div>
      <div>Boomkampsweg 1</div>
      <div>7245 WC Laren</div>
      <div>+31 570 751 225</div>
      <div>info&#64;denhollander.info</div>
    </div>
    <div class="flex flex-col gap-1 text-xl text-neutral-800 md:w-1/2">
      <div class="flex items-center gap-2">
        <span class="text-neutral-500"
          >{{ 'pages.contact.info.chamberOfCommerce' | translate }}:</span
        >
        <span>75960532</span>
      </div>
      <div class="flex items-center gap-2">
        <span class="text-neutral-500"
          >{{ 'pages.contact.info.vat' | translate }}:</span
        >
        <span>NL 8604.58.209.B01</span>
      </div>
      <div class="flex items-center gap-2">
        <span class="text-neutral-500"
          >{{ 'pages.contact.info.bank' | translate }}:</span
        >
        <span>NL42 RABO 0118 2360 91</span>
      </div>
      <div class="flex items-center gap-2">
        <span class="text-neutral-500"
          >{{ 'pages.contact.info.bic' | translate }}:</span
        >
        <span>RABONL2U</span>
      </div>
    </div>
  </div>
</div>

<dhp-our-subscriptions></dhp-our-subscriptions>
